import { IconButton } from 'subframe/components/IconButton';
import { Button } from 'subframe/components/Button';
import { Dialog } from 'subframe/components/Dialog';
import { useState } from 'react';
import { deleteTeamInvitation } from 'api/frontend';
import { somethingWentWrong, toastAutoHideDuration } from 'constants/toasts';
import AnalyticsEventLogger from 'utils/AnalyticsEventLogger';
import { useSnackbar } from 'notistack';
import { TeamInvitation } from 'api/models';
import useUserAccountState from 'hooks/useUserAccountState';

export function DeleteInvitationDialog(props: {
  invitation?: TeamInvitation;
  open: boolean;
  setOpen: (open: boolean) => void;
}): JSX.Element {
  const { account } = useUserAccountState();
  const [loading, setLoading] = useState(false);

  const { enqueueSnackbar } = useSnackbar();
  const { logEvent } = AnalyticsEventLogger();

  const deleteInvitation = async () => {
    setLoading(true);
    try {
      await deleteTeamInvitation(
        'default',
        'default',
        props.invitation?.id || '',
        {
          headers: {
            Authorization: `Bearer ${account?.token}`,
          },
        },
      );
      enqueueSnackbar('Team invitation cancelled successfully', {
        variant: 'success',
      });
      logEvent('team-invitation-cancelled', { invitation: props.invitation });
      props.setOpen(false);
    } catch (err) {
      enqueueSnackbar(
        `${somethingWentWrong.replace(
          '<action>',
          'cancelling Team Invitation',
        )}`,
        {
          variant: 'error',
          autoHideDuration: toastAutoHideDuration,
        },
      );
    } finally {
      setLoading(false);
      props.setOpen(false);
    }
  };

  return (
    <>
      <Dialog open={props.open} onOpenChange={() => props.setOpen(!props.open)}>
        <Dialog.Content className="h-auto w-80 flex-none">
          <div className="flex w-full flex-col items-start gap-[24px] p-[24px]">
            <div className="flex w-full items-center justify-between">
              <span className="text-subheader text-default-font">
                Cancel the Invitation?
              </span>
              <IconButton
                icon="FeatherX"
                size="medium"
                onClick={() => props.setOpen(false)}
              />
            </div>
            <div className="flex w-full flex-col items-start gap-[16px]">
              <span className="text-body text-default-font">
                Are you sure you no longer want to invite{' '}
                {props.invitation?.email} to your Chkk Team?
              </span>
            </div>
            <div className="flex w-full items-end justify-end gap-[16px]">
              <Button
                size="large"
                loading={loading}
                disabled={loading}
                variant="destructive-primary"
                icon="FeatherTrash2"
                onClick={() => deleteInvitation()}
              >
                Cancel Invitation
              </Button>
            </div>
          </div>
        </Dialog.Content>
      </Dialog>
    </>
  );
}
